
import { Video, VideoDashboardStore } from './types';

/**
 * Helper function to generate a random color
 */
export const generateRandomColor = () => '#' + Math.floor(Math.random() * 16777215).toString(16);

/**
 * Add creation dates to sample videos
 */
export const addDatesToVideos = (videos: Omit<Video, 'createdAt' | 'folderId' | 'isNew'>[]) => {
  return videos.map(video => ({
    ...video,
    createdAt: new Date(Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000).toISOString(),
    folderId: Math.random() > 0.5 ? null : ['folder1', 'folder2'][Math.floor(Math.random() * 2)],
    isNew: Math.random() > 0.7
  }));
};

/**
 * Add a video to a folder
 */
export const addVideoToFolder = (state: VideoDashboardStore, videoId: string, folderId: string | null) => {
  const updatedVideos = state.videos.map((video) => 
    video.id === videoId ? { ...video, folderId } : video
  );
  
  return {
    ...state,
    videos: updatedVideos
  };
};

/**
 * Remove a video from its folder
 */
export const removeVideoFromFolder = (state: VideoDashboardStore, videoId: string) => {
  const updatedVideos = state.videos.map((video) => 
    video.id === videoId ? { ...video, folderId: null } : video
  );
  
  return {
    ...state,
    videos: updatedVideos
  };
};

/**
 * Update video properties
 */
export const updateVideo = (state: VideoDashboardStore, videoId: string, data: Partial<Video>) => {
  const updatedVideos = state.videos.map((video) => 
    video.id === videoId ? { ...video, ...data } : video
  );
  
  return {
    ...state,
    videos: updatedVideos
  };
};

/**
 * Apply all active filters to videos
 */
export const applyVideoFilters = (state: VideoDashboardStore) => {
  let filteredVideos = [...state.videos];
  
  // Filter by folder
  if (state.activeFolder) {
    filteredVideos = filteredVideos.filter(video => video.folderId === state.activeFolder);
  }
  
  // Filter by search query
  if (state.searchQuery) {
    const query = state.searchQuery.toLowerCase();
    filteredVideos = filteredVideos.filter(video => 
      video.title.toLowerCase().includes(query)
    );
  }
  
  // Filter by status
  if (state.statusFilter === 'processing') {
    filteredVideos = filteredVideos.filter(video => video.status === 'processing');
  } else if (state.statusFilter === 'processed') {
    filteredVideos = filteredVideos.filter(video => video.status === 'processed');
  }
  
  return filteredVideos;
};

/**
 * Get folders that should be visible
 */
export const getVisibleFolders = (state: VideoDashboardStore) => {
  return state.folders;
};
